export function normalizeCpfDigits(value: string): string {
  return value.replace(/\D/g, '').slice(0, 11)
}

export function normalizePhoneDigits(value: string): string {
  return value.replace(/\D/g, '').replace(/^55(?=\d{10,11}$)/, '').slice(0, 11)
}

export function maskPhone(value: string): string {
  const digits = normalizePhoneDigits(value)

  if (digits.length <= 2) return digits
  if (digits.length <= 6) return `(${digits.slice(0, 2)}) ${digits.slice(2)}`
  if (digits.length <= 10) return `(${digits.slice(0, 2)}) ${digits.slice(2, 6)}-${digits.slice(6)}`

  return `(${digits.slice(0, 2)}) ${digits.slice(2, 7)}-${digits.slice(7)}`
}

export function isValidAccountEmail(value: string): boolean {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)
}

export function parseResetInstitutionId(value: string | null): number | null {
  const parsed = Number(value ?? '')
  if (!Number.isFinite(parsed) || parsed <= 0) {
    return null
  }

  return Math.floor(parsed)
}
